import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/activity-items.js";
import "@ui5/webcomponents-icons/dist/badge.js";
import "@ui5/webcomponents-icons/dist/compare.js";
import "@ui5/webcomponents-icons/dist/customer.js";
import "@ui5/webcomponents-icons/dist/money-bills.js";
import "@ui5/webcomponents-icons/dist/favorite.js";
import "@ui5/webcomponents-icons/dist/settings.js";
import "@ui5/webcomponents-icons/dist/sales-quote.js";
import "@ui5/webcomponents-icons/dist/group.js";

import { loyaltyPermissions } from "./permissions";

/** Loyalty & Gift Cards entries of the navigation registry (group `loyalty`, plan module `loyalty`). */
export const loyaltyNavigation: readonly NavigationEntry[] = [
  {
    key: "loyalty.accounts",
    labelKey: "nav.lyAccounts",
    icon: "customer",
    path: "/loyalty/accounts",
    permission: loyaltyPermissions.accountView,
  },
  {
    key: "loyalty.giftCards",
    labelKey: "nav.lyGiftCards",
    icon: "money-bills",
    path: "/loyalty/gift-cards",
    permission: loyaltyPermissions.giftCardView,
  },
  {
    key: "loyalty.programmes",
    subGroup: "setup",
    labelKey: "nav.lyProgrammes",
    icon: "badge",
    path: "/loyalty/programmes",
    permission: loyaltyPermissions.programmeView,
  },
  {
    key: "loyalty.discountCards",
    labelKey: "nav.lyDiscountCards",
    icon: "sales-quote",
    path: "/loyalty/discount-cards",
    permission: loyaltyPermissions.discountCardView,
  },
  {
    key: "loyalty.groupCards",
    labelKey: "nav.lyGroupCards",
    icon: "group",
    path: "/loyalty/group-discount-cards",
    permission: loyaltyPermissions.groupCardView,
  },
  {
    key: "loyalty.adjustments",
    labelKey: "nav.lyAdjustments",
    icon: "activity-items",
    path: "/loyalty/adjustments",
    permission: loyaltyPermissions.accountView,
  },
  {
    key: "loyalty.reconciliation",
    labelKey: "nav.lyReconciliation",
    icon: "compare",
    path: "/loyalty/reconciliation",
    permission: loyaltyPermissions.reconciliationView,
  },
  {
    key: "loyalty.ratings",
    labelKey: "nav.lyRatings",
    icon: "favorite",
    path: "/loyalty/ratings",
    permission: loyaltyPermissions.ratingView,
  },
  {
    key: "loyalty.settings",
    subGroup: "setup",
    labelKey: "nav.lySettings",
    icon: "settings",
    path: "/loyalty/settings",
    permission: loyaltyPermissions.settingsView,
  },
];
